export const apiVersion =
  process.env.NEXT_PUBLIC_SANITY_API_VERSION || '2024-01-08'

export const dataset = process.env.NEXT_PUBLIC_SANITY_DATASET || 'production'

export const token = process.env.NEXT_PUBLIC_SANITY_API_READ_TOKEN || 'skpvSMduURYDxkPfNvqq9efYxsEu8NrIpkysqSvqFgnniwlYO6Df6SyJZ9HSNLX1w6GKxXSZYc2vOcWCWgM4TNFZKyLuJELniNDH7zECxSMCEnBobf8VghJJlCREynwruUX9ccloPAI4cIB5q5PsYXAvaIRrkIZ5C7dWWVOsMTCP3wTXchvS'

if (!token) {
  throw new Error(
    'A secret is provided but there is no `NEXT_PUBLIC_SANITY_API_READ_TOKEN` environment variable setup. '+process.env.NEXT_PUBLIC_SANITY_API_READ_TOKEN ,
  )
}

export const projectId = process.env.NEXT_PUBLIC_SANITY_PROJECT_ID || 'yt1ed4l0'

export const useCdn = false

function assertValue<T>(v: T | undefined, errorMessage: string): T {
  if (v === undefined) {
    throw new Error(errorMessage)
  }

  return v
}

export const STUDIO_ORIGIN = process.env.NODE_ENV !== 'production' ? (process.env.NEXT_PUBLIC_STUDIO_ORIGIN || "/studio") : (process.env.NEXT_PUBLIC_STUDIO_ORIGIN || "/studio");

export const domain = assertValue(
  process.env.NEXT_PUBLIC_DOMAIN,
  'Missing environment variable: NEXT_PUBLIC_DOMAIN'
)

function normalizeDomain(domain: string): string {
  // Remove protocol if present
  const cleanDomain = domain.replace(/^https?:\/\//, '').replace(/\/$/, '')
  
  // Map actual domains to schema values
  if (cleanDomain === 'trademania.io' || cleanDomain === 'www.trademania.io') {
    return 'main'
  }
  if (cleanDomain === 'get.trademania.io') {
    return 'lp'
  }
  if (cleanDomain === 'shop.trademania.io') {
    return 'shop'
  }
  if (cleanDomain === 'bastiankeller.com' || cleanDomain === 'www.bastiankeller.com') {
    return 'bastiankeller'
  }

  // Default fallback for localhost and other development domains
  return 'main'
}

export const normalizedDomain = normalizeDomain(domain)

/**
 * Public origin for each `settings.domain` value. Used to make internal links
 * that point at a page on another domain absolute (e.g. the shared footer's
 * Impressum on bastiankeller.com lives on trademania.io).
 */
export const DOMAIN_ORIGINS: Record<string, string> = {
  main: 'https://www.trademania.io',
  lp: 'https://get.trademania.io',
  shop: 'https://shop.trademania.io',
  bastiankeller: 'https://www.bastiankeller.com',
}
